// extracted by mini-css-extract-plugin
export default {"root":"Timer_root-VQw","separator":"Timer_separator-udP","withPromo":"Timer_withPromo-Vas","text":"Timer_text-TAV","container":"Timer_container-cwe","label":"Timer_label-YIy"};